var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightMagic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.018,
    viewBox: "0 0 24 24.018",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-1822 -1070.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stars-4",
    d: "M145.289,487.367l-3.419-.5a4.431,4.431,0,0,1-3.859-3.859l-.5-3.419a1.168,1.168,0,0,0-2.2,0l-.5,3.419a4.417,4.417,0,0,1-3.8,3.859l-3.419.5a1.168,1.168,0,0,0,0,2.2l3.466.453a4.4,4.4,0,0,1,3.859,3.874l.453,3.466a1.168,1.168,0,0,0,2.2,0l.5-3.419a4.38,4.38,0,0,1,3.859-3.859l3.419-.5a1.168,1.168,0,0,0,0-2.2Z",
    transform: "translate(1695.19 595.905)",
    fill: "#ff5b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stars-4-2",
    "data-name": "stars-4",
    d: "M135.769,482.959l-1.658-.242a2.148,2.148,0,0,1-1.871-1.871L132,479.188a.566.566,0,0,0-1.068,0l-.242,1.658a2.141,2.141,0,0,1-1.842,1.871l-1.658.242a.566.566,0,0,0,0,1.068l1.68.22a2.133,2.133,0,0,1,1.871,1.878l.22,1.68a.566.566,0,0,0,1.068,0l.242-1.658a2.123,2.123,0,0,1,1.871-1.871l1.658-.242a.566.566,0,0,0,0-1.068Z",
    transform: "translate(1709.825 591.219)",
    fill: "#ffb450"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightMagic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Light_Magic.95a8fa75a5faeb2ced8a609d90e0d248.svg";